<template>
    <div style="text-align: center">
        <div>Please upload your enrollment file in Excel format.</div>
        <div class="mt-4">
            <amf-button class="btn-default" :onClick="download">Download Online Enrollment File</amf-button>
        </div>
        <div class="p-1">
            <label class="btn btn-success btn-file">
                Upload Online Enrollment File <input type="file" ref="uploader" style="display: none;" @change="fileSelected" />
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: ["item"],
    computed: {
    },
    methods: {
        ...amfx.map("actionItems", "changeStatus, validateCanChangeStatus"),
        ...amfx.map("employer", "isFirstData"),
         async fileSelected() {
            this.busy = true;

            let formData = new FormData();
            formData.append('file', this.$refs.uploader.files[0]);

            var errors = await romeApi.upload(`employer/onlineenrollment/${this.item.employerId}/enrollment/upload/${this.item.actionItemId}`, formData);

            this.$refs.uploader.value = null; 

            if(errors && errors.length > 0){        
                await showEnrollmentErrorsModal(errors, this.item.employerId);
                return false;
            } else {
            
                var canChangeStatus = await this.validateChangeStatusRequest(this.item, "completed");

                if(canChangeStatus.ok == true){
                    await this.changeActionItemStatus("completed");
                    this.busy = false;
                    
                    var successMessage = 'Your enrollments have been successfully uploaded ';
                    
                    await modalService.info(successMessage);
                }
            }
            this.busy = false;
        },
        async changeActionItemStatus(newStatus) {
            try {
                await this.changeStatus({ actionItem: this.item, newStatus: newStatus, onComplete: this.onComplete });
                this.refreshPermissions();
            }
            catch(err)
            {
                console.log(err);
                modalService.info(err.message);
            }
        },
        async download() {               
            this.busy = true;
            await romeApi.download(`employer/onlineenrollment/${this.item.employerId}/enrollment/download`);          
            this.busy = false;     
        },
        async validateChangeStatusRequest(newStatus){

            let result = await this.validateCanChangeStatus({ actionItem: this.item, newStatus:newStatus });

            if(!result.canChangeStatus.ok){
                var errors = [];
                errors.push({error: result.message});
                var dto = {errors: errors};

                await modalService.info(result.message, {
                    buttonsCustom: [{
                        name: "Download Errors",
                        onClick: async () =>await romeApi.postDownload(`actionitem/v-2/${this.item.actionItemId}/errors/download`, null, dto)
                    }]
                });
            }
            return result.canChangeStatus.ok;
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/action-items/types/SetUpOnlineEnrollments.vue